var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineKamLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "628.000000pt",
    height: "107.000000pt",
    viewBox: "0 0 628.000000 107.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,107.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 540 l0 -460 420 0 421 0 -3 93 -3 92 -322 3 -323 2 0 365 0 365 -95 0 -95 0 0 -460z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 905 l0 -95 45 0 45 0 0 -270 0 -270 -45 0 -45 0 0 -95 0 -95 190 0 190 0 0 95 0 95 -45 0 -45 0 0 270 0 270 45 0 45 0 0 95 0 95 -190 0 -190 0 0 -95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 541 l0 -461 95 0 95 0 0 245 c0 135 3 245 6 245 6 0 73 -50 407 -307 130 -101 240 -183 242 -183 3 0 5 207 5 460 l0 461 -97 -3 -98 -3 -3 -249 -2 -249 -23 20 c-12 11 -130 103 -262 203 -132 101 -268 205 -302 232 l-63 50 0 -461z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 540 l0 -460 420 0 421 0 -3 93 -3 92 -322 3 -323 2 0 85 0 85 325 0 326 0 -3 98 -3 97 -320 2 -320 2 -3 86 -3 85 326 0 325 0 0 95 0 95 -420 0 -420 0 0 -460z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3120 540 l0 -460 95 0 95 0 0 203 0 202 373 244 c204 135 379 251 387 258 12 11 -15 13 -159 13 l-174 0 -209 -125 c-115 -69 -211 -125 -214 -125 -2 0 -4 56 -4 125 l0 125 -95 0 -95 0 0 -460z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5240 540 l0 -460 95 0 95 0 2 243 3 242 78 -148 79 -148 136 3 137 3 75 145 75 145 3 -242 2 -243 95 0 95 0 0 460 0 461 -96 -3 -96 -3 -142 -277 c-77 -153 -144 -278 -148 -278 -4 0 -71 126 -150 280 l-143 280 -97 0 -98 0 0 -460z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4577 848 c-46 -79 -166 -281 -266 -450 -99 -169 -181 -310 -181 -313 0 -3 46 -5 103 -5 l102 0 165 290 c90 159 167 287 170 282 13 -14 250 -409 250 -416 0 -3 -87 -6 -194 -6 l-194 0 -41 -71 c-23 -39 -41 -73 -41 -75 0 -2 171 -4 379 -4 l380 0 -267 455 c-147 250 -270 454 -274 455 -4 0 -45 -64 -91 -142z",
    fill: "#D8042A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3650 614 c-36 -25 -71 -48 -78 -53 -10 -5 13 -66 92 -242 l105 -234 107 -3 c67 -2 105 1 102 7 -13 40 -254 571 -258 570 -3 0 -34 -20 -70 -45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineKamLogoLight);
export default __webpack_public_path__ + "static/media/LineKamLogoLight.a6411ee9ab1fd10e0a1c63ed690f4f04.svg";
export { ForwardRef as ReactComponent };